export default __webpack_public_path__ + "static/media/pcshield.2f12a424.png";